export default __webpack_public_path__ + "5030ee863e2665fe01dfa2346ddeaa9c.png";